import { createApp } from 'vue'
import App from './App.vue'
import '@/utils/security'
import locale from "element-plus/es/locale/lang/zh-cn";// 需要新加的代码
import * as directives from '@/directives'

import EsayParam from "@/api/easy";
import EsayInfo from "@/api/easyInfo";
import getSelectApi from "@/api/getSelectApi";
import exportApi from "@/api/exportApi";


import '@/theme/TeQian/assets/css/base.scss'
import store from './store'
import axios from './utils/request.js'
// import axiostld from './utils/request-tld.js'
import {queryNoneReqbody,queryPostApi,authorityManagement} from './utils/requestNoneReqBody.js'
import './permission' // 注册路由前置拦截鉴权

import element from 'element-plus'
import { ElMessage , ElMessageBox} from 'element-plus'
import { messageNew } from '@/utils/resetMe'
import 'element-plus/theme-chalk/index.css'
import "@/theme/TeQian/assets/iconfont/iconfont.css"
import * as ElementPlusIconsVue from '@element-plus/icons-vue'
import router from './router/router'

// import BaiduMap from 'vue-baidu-map-3x'//地图

import components from "@/theme/TeQian/components/elConfig/index.js";

const app = createApp(App);

for (const [key, component] of Object.entries(ElementPlusIconsVue)) {
    app.component(key, component)
}
app.config.warnHandler = () => null;
app.config.globalProperties.$axios = axios;

app.config.globalProperties.$EsayParam = EsayParam;
app.config.globalProperties.$EsayInfo = EsayInfo;
app.config.globalProperties.$exportApi = exportApi;
app.config.globalProperties.$getSelectApi = getSelectApi;

Object.keys(directives).forEach((key) => {
    app.directive(key, directives[key]);
})
app.use(components);
app.use(element,{locale})
app.config.globalProperties.$axiosNoneReqBody = queryNoneReqbody;
app.config.globalProperties.$queryPostApi = queryPostApi;
app.config.globalProperties.$messageNew = messageNew;
app.config.globalProperties.$Elmessage = ElMessage;
app.config.globalProperties.$ElMessageBox = ElMessageBox;
app.config.globalProperties.$authorityManagement = authorityManagement;

app.use(element,{}).use(store).use(router).mount('#app')

// app.use(BaiduMap, {
//     ak: 'N8EG7yVmqRTppmWX3ValYeT22aC4s0Ca'
// })